module.exports = __webpack_public_path__ + "4809f1b5a38c0152a36133f27bb19f5b.MP3";